export const QuestionsTextFR: QuestionsText = {
  relationship_status: {
    id: 'relationship_status',
    inputtype: 'radio',
    sort: 3,
    question: 'Quel est votre statut relationnel actuel?',
    options: [
      {
        value: 'single',
        label: 'Célibataire',
      },
      {
        value: 'closed',
        label: 'Relation exclusive',
      },
      {
        value: 'open',
        label: 'Relation ouverte',
      },
      {
        value: 'polyamorous',
        label: 'Polyamoureux',
      },
      {
        value: 'other',
        label: 'Autre',
      },
    ],
  },
  relationship_duration: {
    id: 'relationship_duration',
    inputtype: 'slider',
    min: 0,
    max: 50,
    step: 1,
    initial: 0,
    unit: 'Jahre',
    sort: 4,
    question:
      'Depuis combien de temps êtes-vous dans cette relation (pour plusieurs, la plus longue)?',
    labels: {
      min: "moins d'un an",
      max: '50 ans et plus',
    },
  },
  relationship_duration_single: {
    id: 'relationship_duration',
    inputtype: 'slider',
    min: 0,
    max: 50,
    step: 1,
    initial: 0,
    unit: 'Jahre',
    sort: 4,
    question: 'Depuis combien de temps êtes-vous célibataire?',
    labels: {
      min: "moins d'un an",
      max: '50 ans et plus',
    },
  },
  gender: {
    id: 'gender',
    inputtype: 'radio',
    sort: 0,
    question: 'Avec quel genre vous identifiez-vous?',
    options: [
      {
        value: 'female',
        label: 'Femme',
      },
      {
        value: 'male',
        label: 'Homme',
      },
      {
        value: 'intersexual',
        label: 'Intersexe',
      },
      {
        value: 'other',
        label: 'Divers (trans, non-binaire, autres)',
      },
    ],
  },
  sexual_orientation: {
    id: 'sexual_orientation',
    inputtype: 'radio',
    sort: 5,
    question: 'Quelle est votre orientation sexuelle?',
    options: [
      {
        value: 'heterosexual',
        label: 'Hétérosexuelle',
      },
      {
        value: 'bisexual',
        label: 'Bisexuelle',
      },
      {
        value: 'homosexual',
        label: 'Homosexuelle',
      },
      {
        value: 'other',
        label: 'Autre (pansexuelle, etc.)',
      },
    ],
  },
  age: {
    id: 'age',
    inputtype: 'radio',
    sort: 1,
    question: 'Quel âge avez-vous?',
    options: [
      {
        value: 'age_18_to_29',
        label: '18 à 29 ans',
      },
      {
        value: 'age_30_to_39',
        label: '30 à 39 ans',
      },
      {
        value: 'age_40_to_49',
        label: '40 à 49 ans',
      },
      {
        value: 'age_50_to_59',
        label: '50 à 59 ans',
      },
      {
        value: 'age_60_to_69',
        label: '60 à 69 ans',
      },
      {
        value: 'age_70_plus',
        label: '70 ans et plus',
      },
    ],
  },
  education: {
    id: 'education',
    inputtype: 'radio',
    sort: 2,
    question: "Quel est votre niveau d'éducation le plus élevé?",
    options: [
      {
        value: 'compulsory',
        label: 'École obligatoire',
      },
      {
        value: 'secondary_2',
        label:
          'Éducation secondaire II (apprentissage professionnel, école de métiers, gymnase)',
      },
      {
        value: 'tertiary_job',
        label:
          'Éducation tertiaire (formation professionnelle supérieure, école professionnelle supérieure, certificat professionnel fédéral)',
      },
      {
        value: 'tertiary_study',
        label:
          'Éducation tertiaire (haute école spécialisée, haute école pédagogique, université)',
      },
      {
        value: 'other',
        label: 'Autre',
      },
    ],
  },
  satisfaction: {
    id: 'satisfaction',
    inputtype: 'slider',
    min: 0,
    max: 10,
    step: 1,
    initial: 5,
    sort: 6,
    question: 'Globalement, êtes-vous satisfait(e) de votre vie sexuelle?',
    labels: {
      min: '0 - pas du tout satisfait',
      max: '10 - très satisfait',
    },
  },
  sex_frequency: {
    id: 'sex_frequency',
    inputtype: 'radio',
    sort: 7,
    question:
      'Combien de fois avez-vous eu des rapports sexuels (de tout type) avec une personne le mois dernier?',
    options: [
      {
        value: 'never',
        label: "Je n'ai pas eu de rapports sexuels le mois dernier",
      },
      {
        value: 'one_to_two_times_month',
        label: '1-2 fois par mois',
      },
      {
        value: 'three_to_four_times_month',
        label: '3-4 fois par mois',
      },
      {
        value: 'two_to_three_times_week',
        label: '2-3 fois par semaine',
      },
      {
        value: 'four_to_five_times_week',
        label: '4–5 fois par semaine',
      },
      {
        value: 'six_to_seven_times_week',
        label: '6-7 fois par semaine',
      },
      {
        value: 'more_than_seven_times_week',
        label: 'Plus de 7 fois par semaine',
      },
      {
        value: 'never_ever',
        label: "Je n'ai jamais eu de rapports sexuels avec une personne.",
      },
    ],
  },
  sex_frequency_desired: {
    id: 'sex_frequency_desired',
    inputtype: 'radio',
    sort: 8,
    question:
      'À quelle fréquence aimeriez-vous avoir des rapports sexuels (de tout type) avec une personne par rapport à votre situation actuelle?',
    options: [
      {
        value: 'much_more',
        label: 'Beaucoup plus souvent',
      },
      {
        value: 'more',
        label: 'Plus souvent',
      },
      {
        value: 'same',
        label: 'Je suis satisfait(e) de ma situation',
      },
      {
        value: 'less',
        label: 'Moins souvent',
      },
      {
        value: 'much_less',
        label: 'Beaucoup moins souvent',
      },
      // {
      //   value: 'no_answer',
      //   label: 'pas de réponse',
      // },
    ],
  },
  orgasm_frequency_sex: {
    id: 'orgasm_frequency_sex',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 9,
    question:
      'Combien de fois avez-vous eu un orgasme lors de relations sexuelles (de tout type) avec quelqu’un le mois dernier?',
    labels: {
      min: '0 - jamais',
      max: '100% - à chaque fois',
    },
  },
  orgasm_frequency_desired: {
    id: 'orgasm_frequency_desired',
    inputtype: 'radio',
    sort: 10,
    question:
      'À quelle fréquence aimeriez-vous avoir un orgasme lors de relations sexuelles (de tout type) par rapport à votre situation actuelle?',
    options: [
      {
        value: 'much_more',
        label: 'Beaucoup plus souvent',
      },
      {
        value: 'more',
        label: 'Plus souvent',
      },
      {
        value: 'same',
        label: 'Je suis satisfait(e) de ma situation',
      },
      {
        value: 'less',
        label: 'Moins souvent',
      },
      {
        value: 'much_less',
        label: 'Beaucoup moins souvent',
      },
      // {
      //   value: 'no_answer',
      //   label: 'pas de réponse',
      // },
    ],
  },
  pleasure_frequency_sex: {
    id: 'pleasure_frequency_sex',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 11,
    question:
      'À quelle fréquence avez-vous ressenti du plaisir sexuel lors de relations sexuelles (de tout type) le mois dernier?',
    labels: {
      min: '0 - jamais',
      max: '100% - à chaque fois',
    },
  },
  masturbation_frequency: {
    id: 'masturbation_frequency',
    inputtype: 'radio',
    sort: 12,
    question:
      'Combien de fois vous êtes-vous masturbé ou masturbée le mois dernier?',
    options: [
      {
        value: 'never',
        label: 'Je ne me suis pas masturbé ou masturbée le mois dernier.',
      },
      {
        value: 'one_to_two_times_month',
        label: '1-2 fois par mois',
      },
      {
        value: 'three_to_four_times_month',
        label: '3-4 fois par mois',
      },
      {
        value: 'two_to_three_times_week',
        label: '2-3 fois par semaine',
      },
      {
        value: 'four_to_five_times_week',
        label: '4–5 fois par semaine',
      },
      {
        value: 'six_to_seven_times_week',
        label: '6-7 fois par semaine',
      },
      {
        value: 'more_than_seven_times_week',
        label: 'plus de 7 fois par semaine',
      },
      {
        value: 'never_ever',
        label: 'Je ne me suis jamais masturbé ou masturbée.',
      },
    ],
  },
  orgasm_frequency_masturbation: {
    id: 'orgasm_frequency_masturbation',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 13,
    question:
      'Combien de fois avez-vous eu un orgasme en vous masturbant le mois dernier?',
    labels: {
      min: '0 - aucune',
      max: '100% - à chaque fois',
    },
  },
  pleasure_frequency_masturbation: {
    id: 'pleasure_frequency_masturbation',
    inputtype: 'slider',
    min: 0,
    max: 100,
    step: 5,
    initial: 50,
    unit: '%',
    sort: 14,
    question:
      'À quelle fréquence avez-vous ressenti du plaisir sexuel (jouissance) en vous masturbant le mois dernier?',
    labels: {
      min: '0 - jamais',
      max: '100% - à chaque fois',
    },
  },
  group_agree: {
    id: 'group_agree',
    inputtype: 'slider',
    sort: 15,
    question:
      "Dans quelle mesure êtes-vous d'accord avec les affirmations suivantes:",
  },
  group_agree_like: {
    id: 'group_agree_like',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 21,
    question: 'Les hommes aiment le sexe plus que les femmes.',
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  group_agree_demand: {
    id: 'group_agree_demand',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 22,
    question: 'Les femmes ont moins de désir sexuel que les hommes.',
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  group_agree_think: {
    id: 'group_agree_think',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 23,
    question: 'Les femmes pensent moins souvent au sexe que les hommes.',
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  genital_look: {
    id: 'genital_look',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 16,
    question:
      "Je suis satisfait ou satisfaite de l'apparence de mes organes génitaux. (Organes génitaux = organes sexuels primaires)",
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  genital_function: {
    id: 'genital_function',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 17,
    question:
      'Je suis satisfait ou satisfaite de la fonction de mes organes génitaux. (Organes génitaux = organes sexuels primaires)',
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  realize_sexual_demands: {
    id: 'realize_sexual_demands',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 18,
    question:
      'Je peux assouvir mes besoins sexuels pendant les relations sexuelles (de tout type) avec une personne.',
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  communicate_needed_mood: {
    id: 'communicate_needed_mood',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 19,
    question:
      "Je peux communiquer à mon ou ma partenaire la stimulation sexuelle dont j'ai besoin pour atteindre l’orgasme.",
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
  right_to_orgasm: {
    id: 'right_to_orgasm',
    inputtype: 'slider',
    min: 0,
    max: 5,
    step: 1,
    initial: 3,
    sort: 20,
    question: "J'ai droit à un orgasme pendant une relation sexuelle",
    labels: {
      min: "0 – Pas du tout d'accord",
      max: "5 – Tout à fait d'accord",
    },
  },
}
